<div class="container" [formGroup]="form">
    <div class="close-btn-fill-area" mat-dialog-close>
        <span class="close-btn">
        </span>
    </div>
    <span class="title">
        {{ 'REJECT_TITLE' | translate }}
    </span>
    <span class="sub-title">
        {{ 'REJECT_SUBTITLE' | translate }}
    </span>
    <span class="label" id="reasons-label">
        {{  'REJECT_TEXT' | translate }}
    </span>

    <mat-form-field id="reasons-select">
        <!-- <mat-label>Favorite food</mat-label> -->
        <mat-select formControlName="reason" >
            <mat-option *ngFor="let reason of arrayRejectionReason" [value]="reason">{{ reason.name }}</mat-option>
        </mat-select>
    </mat-form-field>

    <span class="label" id="report-description-label">
        {{ "REJECT_OTHER_DESCRIPTION" | translate }}
    </span>

    <mat-form-field id="description-input" class="example-full-width">
        <mat-label>{{ "REJECT_DESCRIPTION" | translate }}</mat-label>
        <textarea formControlName="otherDescription" id="description-text-area" matInput placeholder="Description of rejection"></textarea>
    </mat-form-field>

    <button (click)="sendReasonForRejection()" mat-raised-button class="button" id="accent-button"> 
        <span class="accent-ico-btn"></span> 
       {{ "SEND_REASON_REJECTION" | translate }}
    </button>
</div>